import { useState } from "react";
import { Outlet } from "react-router";

import { SandboxAuthGuard } from "./SandboxAuthGuard";
import { SandboxFeedbackWidget } from "./SandboxFeedbackWidget";
import { SandboxHeader } from "./SandboxHeader";
import s from "./SandboxLayout.module.css";
import { SandboxSidebar } from "./SandboxSidebar";

export const SandboxLayout = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <SandboxAuthGuard>
      <section className={s.root}>
        <SandboxHeader
          collapsed={collapsed}
          onToggleCollapse={() => setCollapsed(v => !v)}
        />
        <section className={s.body}>
          <SandboxSidebar collapsed={collapsed} />
          <main className={s.content}>
            <Outlet />
          </main>
        </section>
        <SandboxFeedbackWidget />
      </section>
    </SandboxAuthGuard>
  );
};
